const BASE = import.meta.env.VITE_API_URL;

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const token = localStorage.getItem("jwt");
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options?.headers,
    },
  });

  if (res.status === 401) {
    const body = await res.json().catch(() => ({} as { code?: string }));
    localStorage.removeItem("jwt");
    const motivo =
      body.code === "TOKEN_EXPIRED" ? "session_expired" : "unauthorized";
    window.location.href = `/accedi?motivo=${motivo}`;
    throw new Error("Sessione terminata");
  }

  if (!res.ok) {
    // 429 dal rate limiter è text/plain, non JSON → leggi raw + mostra
    // un messaggio leggibile con i secondi residui da Retry-After.
    if (res.status === 429) {
      const retry = Number(res.headers.get("Retry-After") ?? "0");
      const min = Math.ceil(retry / 60);
      throw new Error(
        `Limite di richieste raggiunto. Riprova tra ${min || 1} minuti.`,
      );
    }
    // Prova prima JSON, poi text, poi un fallback generico.
    let msg: string | undefined;
    try {
      const body = await res.json();
      msg = body?.error;
    } catch {
      try {
        const text = await res.text();
        if (text && text.length < 200) msg = text;
      } catch { /* ignore */ }
    }
    throw new Error(msg ?? `Errore ${res.status}`);
  }

  // 204 No Content
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

export const api = {
  get: <T>(path: string) => apiFetch<T>(path),
  post: <T>(path: string, body?: unknown) =>
    apiFetch<T>(path, { method: "POST", body: JSON.stringify(body ?? {}) }),
  put: <T>(path: string, body?: unknown) =>
    apiFetch<T>(path, { method: "PUT", body: JSON.stringify(body ?? {}) }),
  delete: <T>(path: string) => apiFetch<T>(path, { method: "DELETE" }),
};
